// Try a demo account (request of 30 Oct 2026, items 4 and 5; migration 055). A temporary, isolated demo business with
// synthetic data, started from the sign-in page without a mobile or password. Not the 14-day trial, not the Demo
// package. Off until a Super Admin turns it on.

/** The bounds a Super Admin may set; the database checks the same (migration 055). */
export const DEMO_LIMITS = {
  minutes: [15, 240], maxActive: [1, 50], perIpHour: [1, 20], dailyMax: [1, 1000], maxWrites: [50, 2000]
} as const satisfies Record<string, readonly [number, number]>;
/** The values after migration 055 (the demo itself is off). */
export const DEMO_DEFAULTS = { minutes: 60, maxActive: 10, perIpHour: 3, dailyMax: 100, maxWrites: 400 } as const;

/** The demo business's information: what a visitor sees, and cannot change. Super Admin only. */
export interface DemoTemplate {
  nameEn: string; nameAr: string; city: string; street: string; phone: string; email: string; taxNumber: string; commercialRecord: string;
}
export const DEMO_TEMPLATE_FIELDS = ["nameEn", "nameAr", "city", "street", "phone", "email", "taxNumber", "commercialRecord"] as const satisfies readonly (keyof DemoTemplate)[];

/** GET /api/demo/config (public): whether the sign-in page offers a demo, and for how long one lasts. */
export interface DemoConfigDto { enabled: boolean; minutes: number }
/** POST /api/demo/start: the demo is signed in (cookie) until expiresAt. */
export interface DemoStartDto { expiresAt: string }
/** In /api/auth/me for a demo business. */
export interface MeDemoDto { expiresAt: string }

/** The Super Admin's demo settings and current use. */
export interface PlatformDemoDto {
  enabled: boolean; minutes: number; maxActive: number; perIpHour: number; dailyMax: number; maxWrites: number;
  template: DemoTemplate;
  /** Demos running now, started in the last 24 hours, and ended but not yet purged. */
  usage: { active: number; last24h: number; awaitingPurge: number; purged: number };
  updatedAt: string;
}
export type PlatformDemoInput = Omit<PlatformDemoDto, "usage" | "updatedAt">;
export interface DemoPurgeResultDto { purged: number; rows: number }
